import AssetView from "backbone/projects/views/asset_view.js"
import AssetsCollection from "backbone/projects/collections/assets_collection.js"

export default class AssetsCollectionView extends Backbone.View
  initialize: (options) ->
    @assetsJSON = options.assetsJSON
    @projectId = options.projectId
    @collection = new AssetsCollection
    @subviews = []
    @addAssets()

  render: ->
    @subviews = []
    for asset in @collection.models
      @addAssetView(asset)

    this

  addAssets: ->
    _.each @assetsJSON, (asset) =>
      @collection.add
        id: asset.id
        clipId: @projectId
        small: asset.small
        persisted: true

  addAssetView: (asset) ->
    assetView = new AssetView(asset: asset)
    @subviews.push(assetView)
    @$el.append(assetView.render().el)

  addAssetFromUpload: (upload) =>
    @collection.add({
      clipId: @projectId
      url: upload.url
      fileType: upload.filetype
    }, {at: 0})

    newAsset = @collection.models[0]
    newAssetView = new AssetView(asset: newAsset)
    @subviews.push(newAssetView)
    @$el.prepend(newAssetView.render().el)
    newAssetView.maskLoading()

    newAsset.save
      success: =>
        @saveAssetting(newAsset)
      error: ->
        contently.flash.alert("There was a problem saving this image.")

  saveAssetting: (asset) =>
    asset.saveAssetting
      success: =>
        @$el.find("input[name='use_image']").val(true)
        contently.flash.notice("The image has been successfully added to your project.")
      error: ->
        contently.flash.alert("There was a problem attaching this image to your project.")

  remove: ->
    for subview in @subviews
      subview.remove()
    super()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/assets_collection_view.js.coffee